module.exports = __webpack_public_path__ + "img/slide1_3.dda8f46b.png";